import { FC } from "react";
import { SanityGraphicItem } from "../../graphql-types";
import CtaButton from "./CtaButton";
import * as styles from "./InfoGraphicCard.module.scss";
import PortableText from "./portableText";

export interface InfoGraphicCardProps extends SanityGraphicItem {
  theme: "orange" | "blue";
}

const InfoGraphicCard: FC<InfoGraphicCardProps> = ({
  text,
  title,
  cta,
  theme,
  openInNewTabDisabled,
}) => {
  return (
    <div className={styles.root}>
      <div className={styles.title}>{title}</div>
      <div className={styles.text}>
        <PortableText blocks={text} />
      </div>
      {cta && cta.label && cta.url && (
        <CtaButton
          label={cta.label}
          url={cta.url}
          openInNewTabDisabled={openInNewTabDisabled}
          theme={theme}
        />
      )}
    </div>
  );
};

export default InfoGraphicCard;
